module.exports = __webpack_public_path__ + "6f1f242caf2cdd5c64cc9577d78e7de9.svg";